import { createStyles, makeStyles } from '@material-ui/core';
import { Colors } from '../../../../layout/theme-next';

export const useStyles = makeStyles(theme =>
  createStyles({
    marginBottom: {
      marginBottom: theme.spacing(1),
    },
    marginTop: {
      marginTop: theme.spacing(3),
    },
    boldText: {
      fontWeight: 'bold',
    },
    divider: {
      color: Colors.stroke,
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
    },
  }),
);
